import { memo, useEffect, useState } from "react";

import { LoadingShim } from "@narmi/design_system";
import { ComposeProviders, modules } from "byzantine";
import {
  WireTypeEnum,
  wireTypeSelectorForm,
  type WireType,
} from "byzantine/src/dbbl/businessLogic/modules/internationalWires/WireTransferContainer.form";
import { CurrencyProvider } from "byzantine/src/dbbl/businessLogic/modules/internationalWires";

import Container from "../../../../components/Container";
import {
  WireTransferRedesign,
  WireTransferContainer,
} from "../../../../components/transfer/wires";

import WireTemplatesScreen from "./templates/templates.screen";

type Props = {
  limits: API.Limits.ByType;
};

const Providers = [
  modules.internationalWires.bootstrap.Provider,
  wireTypeSelectorForm.Provider,
  CurrencyProvider,
];

const DomesticWireProviders = [modules.wireTemplates.bootstrap.Provider];

function BootstrappedWireTransfer({
  limits,
  setWireType,
}: Props & { setWireType: (wireType: WireType) => void }) {
  const { loading, load } = modules.wireTemplates.bootstrap.useBootstrap();

  useEffect(() => {
    load();
  }, [load]);

  if (loading) {
    return (
      <LoadingShim isLoading>
        <div style={{ height: "100vh" }} />
      </LoadingShim>
    );
  }

  return (
    <Container>
      <WireTransferRedesign limits={limits} setWireType={setWireType} />
    </Container>
  );
}

function WireTransfer({ limits }: Props) {
  const { fedwireTemplatesEnabled, internationalWires } =
    modules.wireTemplates.useWirePermissions();
  const [wireType, setWireType] = useState<WireType>(WireTypeEnum.None);

  if (internationalWires && wireType !== "domestic") {
    return (
      <ComposeProviders components={Providers}>
        <WireTransferContainer setWireType={setWireType} />
      </ComposeProviders>
    );
  }

  if (fedwireTemplatesEnabled) {
    if (wireType === WireTypeEnum.None) {
      setWireType(WireTypeEnum.Domestic);
    }
    return (
      <Container>
        <WireTemplatesScreen setWireType={setWireType} wireType={wireType} />
      </Container>
    );
  }

  return (
    <ComposeProviders components={DomesticWireProviders}>
      <BootstrappedWireTransfer limits={limits} setWireType={setWireType} />
    </ComposeProviders>
  );
}

export default memo(WireTransfer);
